import {
  FETCH_COMMISSION_ALL,
  FETCH_COMMISSION_ALL_SUCCEED,
  FETCH_COMMISSION_ALL_FAILED,
  FETCH_COMMISSION_BY_TIME,
  FETCH_COMMISSION_BY_TIME_SUCCEED,
  FETCH_COMMISSION_BY_TIME_FAILED,
  FETCH_COMMISSION_USER,
  FETCH_COMMISSION_USER_SUCCEED,
  FETCH_COMMISSION_USER_FAILED,
  FETCH_COMMISSION_USERS_PAGINATE,
  FETCH_COMMISSION_USERS_PAGINATE_SUCCEED,
  FETCH_COMMISSION_USERS_PAGINATE_FAILED,
  FETCH_COMMISSION_USER_BY_TIME,
  FETCH_COMMISSION_USER_BY_TIME_SUCCEED,
  FETCH_COMMISSION_USER_BY_TIME_FAILED,
  FETCH_TOTAL_REFERRAL,
  FETCH_TOTAL_REFERRAL_SUCCEED,
  FETCH_TOTAL_REFERRAL_FAILED,
  FETCH_LIST_MAP_LEVEL,
  FETCH_LIST_MAP_LEVEL_SUCCEED,
  FETCH_LIST_MAP_LEVEL_FAILED,
  FETCH_LIST_PARTNERS,
  FETCH_LIST_PARTNERS_SUCCEED,
  FETCH_LIST_PARTNERS_FAILED,
} from './action_types';

export default {
  fetchCommissionAll: (params, callback) => ({
    type: FETCH_COMMISSION_ALL,
    params,
    callback,
  }),
  fetchCommissionAllSucceed: (data) => ({
    type: FETCH_COMMISSION_ALL_SUCCEED,
    data,
  }),
  fetchCommissionAllFailed: (err) => ({
    type: FETCH_COMMISSION_ALL_FAILED,
    err,
  }),

  fetchCommissionByTime: (params, callback) => ({
    type: FETCH_COMMISSION_BY_TIME,
    params,
    callback,
  }),
  fetchCommissionByTimeSucceed: (data) => ({
    type: FETCH_COMMISSION_BY_TIME_SUCCEED,
    data,
  }),
  fetchCommissionByTimeFailed: (err) => ({
    type: FETCH_COMMISSION_BY_TIME_FAILED,
    err,
  }),

  fetchCommissionUser: (params, callback) => ({
    type: FETCH_COMMISSION_USER,
    params,
    callback,
  }),
  fetchCommissionUserSucceed: (data) => ({
    type: FETCH_COMMISSION_USER_SUCCEED,
    data,
  }),
  fetchCommissionUserFailed: (err) => ({
    type: FETCH_COMMISSION_USER_FAILED,
    err,
  }),

  fetchCommissionUsers: (params, callback) => ({
    type: FETCH_COMMISSION_USERS_PAGINATE,
    params,
    callback,
  }),
  fetchCommissionUsersSucceed: (data) => ({
    type: FETCH_COMMISSION_USERS_PAGINATE_SUCCEED,
    data,
  }),
  fetchCommissionUsersFailed: (err) => ({
    type: FETCH_COMMISSION_USERS_PAGINATE_FAILED,
    err,
  }),
  fetchCommissionUserByTime: (params, callback) => ({
    type: FETCH_COMMISSION_USER_BY_TIME,
    params,
    callback,
  }),
  fetchCommissionUserByTimeSucceed: (data) => ({
    type: FETCH_COMMISSION_USER_BY_TIME_SUCCEED,
    data,
  }),
  fetchCommissionUserByTimeFailed: (err) => ({
    type: FETCH_COMMISSION_USER_BY_TIME_FAILED,
    err,
  }),

  fetchTotalReferal: (callback) => ({
    type: FETCH_TOTAL_REFERRAL,
    callback,
  }),
  fetchTotalReferalSucceed: (data) => ({
    type: FETCH_TOTAL_REFERRAL_SUCCEED,
    data,
  }),
  fetchTotalReferalFailed: (err) => ({
    type: FETCH_TOTAL_REFERRAL_FAILED,
    err,
  }),

  fetchListMapLevel: (params, callback) => ({
    type: FETCH_LIST_MAP_LEVEL,
    params,
    callback,
  }),
  fetchListMapLevelSucceed: (data) => ({
    type: FETCH_LIST_MAP_LEVEL_SUCCEED,
    data,
  }),
  fetchListMapLevelFailed: (err) => ({
    type: FETCH_LIST_MAP_LEVEL_FAILED,
    err,
  }),

  fetchListPartners: (params, callback) => ({
    type: FETCH_LIST_PARTNERS,
    params,
    callback,
  }),
  fetchListPartnersSucceed: (data, totalCount) => ({
    type: FETCH_LIST_PARTNERS_SUCCEED,
    data,
    totalCount,
  }),
  fetchListPartnersFailed: (err) => ({
    type: FETCH_LIST_PARTNERS_FAILED,
    err,
  }),
};
